import React from "react";
import {Card, Col, Row, Typography} from "antd";

import ErrorBoundary from "../../../components/ErrorBoundary";
import {useAppSelector} from "../../../hooks/useStore";

import {dataColSize, labelColSize} from "../../../assets/styles";
const {Text} = Typography;

const LoginDetails = () => {
    const data = useAppSelector(state => state.user.person);
    return (
        <ErrorBoundary>
            <Card
                title="Login Details"
                hoverable={false}
                bordered={true}
            >
                <Row>
                    <Col {...labelColSize}>
                        <Text strong>Email Address:</Text>
                    </Col>
                    <Col {...dataColSize}>
                        <span className="long-text-wrap">{data?.email || 'N/A'}</span>
                    </Col>
                </Row>
            </Card>
        </ErrorBoundary>
    )
};

export default LoginDetails;
